import { inject, Pipe, PipeTransform } from '@angular/core';
import { TimeZoneService } from '../../../common/time-zone/time-zone.service';
import { DateTime } from 'luxon';

@Pipe({
  name: 'toLocalTime',
  standalone: true,
})
export class ToLocalTimePipe implements PipeTransform {
  private timeZoneService = inject(TimeZoneService);

  transform(
    value: string | Date | DateTime | undefined,
    format: string = 'dd-MM-yyyy HH:mm:ss',
    locale: string = 'fr-FR',
  ): string {
    if (!value) return '';

    const timeZoneId: string = this.timeZoneService.getTimezone();

    let date: DateTime;
    if (value instanceof DateTime) {
      const dateTimeOffset = value.toISO();
      if (dateTimeOffset)
        date = DateTime.fromISO(dateTimeOffset, { setZone: true });
      else return '';
    } else {
      const isoString = value instanceof Date ? value.toISOString() : value;

      date = DateTime.fromISO(isoString, { zone: 'Utc' });
    }

    if (!date.isValid) {
      console.warn('Date invalide :', date.toString());
      return value.toString();
    }
    // Custom format
    return date.setZone(timeZoneId).setLocale(locale).toFormat(format);
  }
}
